import { getIsAcceptanceTest } from './isAcceptanceTest';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import { track } from 'quartz-tracking/service';
const deviceId = makeUuid();
export const trackInteraction = args => {
  if (getIsAcceptanceTest()) {
    return;
  }
  track('Data Privacy Request Ui', 'Interaction', Object.assign({
    deviceId
  }, args));
};
export const trackPageView = args => {
  if (getIsAcceptanceTest()) {
    return;
  }
  track('Data Privacy Request Ui', 'Pageview', Object.assign({
    deviceId
  }, args));
};